exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ResultsEventCard__resultEventCardContainer--bMlPu {\n  padding: 15px;\n}\n\n.ResultsEventCard__statusTitle--20LbT {\n  font-size: 13px;\n  color: #f9f9f9;\n  opacity: 0.65;\n  font-weight: 500;\n  line-height: 1.46;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.ResultsEventCard__statusLive--366qE {\n  color: #1bb955;\n  opacity: 1;\n}\n\n.ResultsEventCard__eventName--srXx0 {\n  margin-top: 5px;\n  font-size: 18px;\n  font-weight: 400;\n  color: #f9f9f9;\n}\n\n@media (max-width: 768px) {\n  .ResultsEventCard__resultEventCardContainer--bMlPu {\n    padding: 10px;\n  }\n  .ResultsEventCard__eventName--srXx0 {\n    font-size: 14px;\n    font-weight: 400;\n  }\n}", ""]);

// exports
exports.locals = {
	"resultEventCardContainer": "ResultsEventCard__resultEventCardContainer--bMlPu",
	"statusTitle": "ResultsEventCard__statusTitle--20LbT",
	"statusLive": "ResultsEventCard__statusLive--366qE",
	"eventName": "ResultsEventCard__eventName--srXx0"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };